import { render, staticRenderFns } from "./wxexplan.vue?vue&type=template&id=07639e94&scoped=true&"
import script from "./wxexplan.vue?vue&type=script&lang=js&"
export * from "./wxexplan.vue?vue&type=script&lang=js&"
import style0 from "./wxexplan.vue?vue&type=style&index=0&id=07639e94&lang=scss&scoped=true&"
import style1 from "./wxexplan.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07639e94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07639e94')) {
      api.createRecord('07639e94', component.options)
    } else {
      api.reload('07639e94', component.options)
    }
    module.hot.accept("./wxexplan.vue?vue&type=template&id=07639e94&scoped=true&", function () {
      api.rerender('07639e94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxexplan.vue"
export default component.exports